<template>
  <div class="main-content">
    <top-container
      :image="headerImage"
      :pageTitle="pageTitle"
      :isHomepage="homepage" />

    <div class="spacer">&nbsp;</div>
    <div class="col" v-html="pageContent.content.reportForm.html"></div>

    <div class="col">
        <template v-for="(element, index) in pageContent.content.reportForm.form.fields">
            <div v-if="element.type === 'title'" :key="element.id">
                <div class="end-of-box" v-if="index > 1"></div>
                <div class="form-group-title">
                    <h2>{{ element.title }}</h2>
                </div>
            </div>

            <div v-if="element.type === 'subtitle'" :key="element.id">
                <div class="end-of-box" v-if="pageContent.content.reportForm.form.fields[index -1].type !== 'title'"></div>
                <div class="start-of-box"></div>

                <div class="box-title">
                    <div class="form-group">
                        <h3>{{ element.title }}</h3>
                    </div>
                </div>
            </div>

            <div v-if="element.type === 'spacer'" :key="element.id">
                <div class="form-group">
                    <br />&nbsp;
                </div>
            </div>

            <div v-if="element.type === 'text'" :key="element.id">
                <div class="box-content">
                    <div class="form-group row">
                        <label for="" class="col-sm-4 col-form-label">{{ element.title }}:</label>
                        <div class="col-sm-8">
                            <input type="text" :name="element.title" v-validate :required="element.required" v-model="element.value" class="form-control" :placeholder="element.title" />
                            <span class="form-error">{{ errors[element.title] }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="element.type === 'textarea'" :key="element.id">
                <div class="box-content">
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label" :for="element.title">{{ element.title }}</label>
                        <div class="col-sm-8">
                            <textarea :name="element.title" v-validate :id="element.title" :required="element.required" v-model="element.value" class="text-form"></textarea>
                            <span class="form-error">{{ errors[element.title] }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="element.type === 'dropdown'" :key="element.id">
                <div class="box-content">
                    <div class="form-group row">
                        <label :for="element.title" class="col-sm-4 col-form-label">{{ element.title }}:</label>
                        <div class="col-sm-8">
                            <select :name="element.title" v-validate :required="element.required" :model="element.value" v-on:change="handleSelect(element, $event)" class="form-control">
                                <template v-for="option in element.options">
                                    <option :value="option.value" :key="option.value">{{ option.value }}</option>
                                </template>
                            </select>
                            <span class="form-error">{{ errors[element.title] }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="element.type === 'radio'" :key="element.id">
                <div class="box-content">
                    <div class="form-group row">
                        <div class="col-sm-12" style="text-align: right;">
                            <label :for="element.title" class="form-label" style="display: block;">{{ element.title }}</label>
                            <template v-for="option in element.options">
                                <div class="custom-control custom-radio custom-control-inline" :key="option.value">
                                    <input type="radio" :id="option.value" :name="element.title" :value="option.value" :model="element.value" v-on:change="handleRadio(element, $event)" class="custom-control-input">
                                    <label class="custom-control-label" :for="option.value">{{ option.value }}</label>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="element.type === 'date'" :key="element.id">
                <div class="box-content">
                    <div class="form-group row">
                        <label for="" class="col-sm-4 col-form-label">{{ element.title }}:</label>
                        <div class="col-sm-8">
                            <input type="date" :name="element.title" v-validate :required="element.required" v-model="element.value" class="form-control" placeholder="dd-mm-jjjj" />
                            <span class="form-error">{{ errors[element.title] }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="element.type === 'time'" :key="element.id">
                <div class="box-content">
                    <div class="form-group row">
                        <label for="" class="col-sm-4 col-form-label">{{ element.title }}:</label>
                        <div class="col-sm-8">
                            <input type="time" :name="element.title" v-validate :required="element.required" v-model="element.value" class="form-control" placeholder="dd-mm-jjjj" />
                            <span class="form-error">{{ errors[element.title] }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="element.type === 'email'" :key="element.id">
                <div class="box-content">
                    <div class="form-group row">
                        <label for="" class="col-sm-4 col-form-label">{{ element.title }}:</label>
                        <div class="col-sm-8">
                            <input type="email" :name="element.title" v-validate :required="element.required" v-model="element.value" class="form-control" :placeholder="element.title" />
                            <span class="form-error">{{ errors[element.title] }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="element.type === 'photo'" :key="element.id">
                <div class="box-content">
                    <div class="form-group row">
                        <label for="" class="col-sm-4 col-form-label">{{ element.title }}:</label>
                        <div class="col-sm-8">
                            <input  :name="element.title"
                                    v-validate
                                    :required="element.required"
                                    type="file"
                                    accept="image/*;capture=camera"
                                    @change="onFileChange($event, element)"
                                    class="form-control"
                                    :placeholder="element.title" />
                            <span class="form-error">{{ errors[element.title] }}</span>

                            <div class="image-preview">
                              <img :src="element.value" title="Photo Preview" @click="removePhoto(element)" />
                              <p v-if="typeof element.value !== 'undefined' && element.value !== null && element.value.length  > 0">
                                <em>Tap the photo to remove it.</em>
                              </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>

        <div class="end-of-box">
        </div>

        <div class="form-group row" style="display: none;">
            <label for="" class="col-sm-4 col-form-label">AIS Data:</label>
            <div class="col-sm-8">
                <input type="hidden" name="AIS Data" style="display: none;" v-model="aisData" class="form-control" placeholder="AIS Data" />
            </div>
        </div>

        <div class="form-group-buttons">
            <div class="btn call-to-action-btn btn-zoom" v-on:click="sendForm" v-if="noFormSendYet && !hasErrors">
                {{ pageContent.content.reportForm.form.settings.send_button_text }}
            </div>
            <span class="form-error" v-if="hasErrors">There are errors in this form, please scroll up and correct these errors</span>
            <div class="spinner-border" role="status" v-if="sendingForm">
              <font-awesome-icon :icon="spinner" class="fa-spin spinner"></font-awesome-icon>
            </div>
        </div>

        <div v-if="!sendingForm">
            <div class="alert alert-success" v-if="sendFormOk" v-html="pageContent.content.reportForm.form.settings.send_succes_message">
            </div>

            <div v-if="!noFormSendYet">
                <div class="alert alert-danger" v-if="!sendFormOk" v-html="pageContent.content.reportForm.form.settings.send_failed_message">
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { ValidateMixin } from '../mixins/validate'
import { faSpinner } from '@fortawesome/free-solid-svg-icons/faSpinner'

export default {
  name: 'Page',
  mixins: [ValidateMixin],
  watch: {
    getPage (oldPage, newPage) {
      if (newPage === null && oldPage !== null) {
        this.setupPage()
      }
      if (newPage !== null && typeof newPage.content === 'undefined') {
        // Store is not finished yet. Let's come back (for now) in about a second or so.
        setTimeout(() => this.setupPage(), 1000)
      } else {
        this.setupPage()
      }
    }
  },
  mounted () {
    this.setupPage()
  },
  data () {
    return {
      loading: true,
      slug: null,
      langId: null,
      pageInfo: null,
      headerImage: null,
      siteName: '',
      logo: null,
      pageTitle: '',
      metaDescription: '',
      reportForm: false,
      altLangUrl: [],
      homepage: false,
      currentPath: this.$route.path,
      menuInfo: [],
      languageMenu: [],
      isoCode: 'nl',
      sendSuccess: false,
      sendFailed: false,
      sendMessage: 'Message',
      aisData: '',
      spinner: faSpinner,
      pageContent: {
        content: {
          reportForm: {
            html: '',
            form: {
              fields: [],
              settings: []
            }
          }
        }
      }
    }
  },
  metaInfo () {
    return {
      title: this.pageTitle,
      titleTemplate: '%s | ' + this.siteName,
      meta: [
        { vmid: 'description', name: 'description', content: this.metaDescription }
      ],
      link: this.getAlternativeLinks,
      htmlAttrs: {
        lang: this.isoCode
      }
    }
  },
  computed: {
    ...mapGetters('graduates', [
      'getAll'
    ]),
    ...mapGetters('form', [
      'sendingForm',
      'sendFormOk',
      'noFormSendYet'
    ]),
    ...mapGetters('website', [
      'getWebsite',
      'getCurrentLanguage',
      'getFooterMenuInfo',
      'getMenuInfo',
      'getAlternativeLinks',
      'getLanguageMenu',
      'getLogo',
      'getCookieInfo'
    ]),
    ...mapGetters('page', [
      'getPage'
    ])
  },
  methods: {
    handleSelect (element, event) {
      element.value = event.target.value
    },
    handleRadio (element, event) {
      element.value = event.target.value
    },
    onFileChange (e, element) {
      var files = e.target.files || e.dataTransfer.files

      if (!files.length) {
        return
      }

      this.createImage(files[0], element)
    },
    createImage (file, element) {
      const reader = new FileReader()

      reader.onload = (e) => {
        const index = this.pageContent.content.reportForm.form.fields.indexOf(element)
        this.pageContent.content.reportForm.form.fields[index].value = e.target.result

        this.$forceUpdate()
      }

      reader.readAsDataURL(file)
    },
    removePhoto (element) {
      const index = this.pageContent.content.reportForm.form.fields.indexOf(element)
      this.pageContent.content.reportForm.form.fields[index].value = null

      this.$forceUpdate()
    },
    setupPage () {
      if (this.currentPath.length > 1) {
        if (this.currentPath.length >= 4 && this.currentPath.substring(3, 4) !== '/') {
          window.location.href = '/'
        } else {
          if ((this.currentPath.substring(1, 3) !== 'nl') &&
              (this.currentPath.substring(1, 3) !== 'en') &&
              (this.currentPath.substring(1, 3) !== 'de')) {
            window.location.href = '/'
          }
        }
      }

      if (this.getWebsite !== null) {
        this.siteName = this.getWebsite.siteName
        this.logo = this.getLogo
        this.menuInfo = this.getMenuInfo
        this.languageMenu = this.getLanguageMenu(this.currentPath)
      }

      this.pageInfo = this.getPage
      if (this.pageInfo === null) {
        return
      }

      if (typeof this.pageInfo.content === 'undefined') {
        return
      }

      this.reportForm = false
      this.loading = false

      if (typeof this.getCurrentLanguage === 'undefined') {
        return
      }

      this.isoCode = this.getCurrentLanguage.isoCode
      this.pageContent = this.pageInfo.content[this.getCurrentLanguage.isoCode]
      this.headerImage = this.pageContent.content.headerImage
      this.pageTitle = this.pageContent.title
      this.metaDescription = this.pageContent.content.meta_description
      this.homepage = this.pageContent.homepage
    },
    sendForm () {
      this.validate()

      if (!this.hasErrors) {
        // Add the fake field to this form...
        this.pageContent.content.reportForm.form.fields.push({
          id: '',
          type: 'hidden',
          title: 'AIS Data',
          value: this.aisData,
          required: false
        })

        this.$store.dispatch('form/send', {
          data: {
            slug: this.pageContent.slug,
            path: this.$route.path,
            iso: this.$route.params.lang,
            fields: this.pageContent.content.reportForm.form.fields
          }
        })
      }
    }
  }
}
</script>

<style scoped>
.cookie__floating {
  max-width: 450px;
  height: 435px;
}

.cookie__floating__content {
  max-height: 400px;
}

.form-error {
  color: red;
  font-style: italic;
  font-size: 12px;
}

.main-content {
  min-height: 500px;
}

.main-content .col {
  padding-left: 10px;
  padding-right: 10px;
}

.image-preview {
  background-color: #d0e3f3;
  padding-top: 10px;
  text-align: center;
  padding-bottom: 10px;
}

.image-preview img {
  max-width: 90%;
  width: 90%;
  border-radius: 10px;
  height: auto;
}

.start-of-box {
  margin-top: 10px;
}

.col h2 {
  padding-top: 30px;
  padding-left: 5px;
}

.call-to-action-btn {
  font-size: 15px;
  background-color: #ce5e31;
  color: #fff;
  border-radius: 20px;
  width: auto;
}

.end-of-box {
  height: 10px;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  border: 1px solid #959595;
  border-top: 0px solid #959595;
}

.box-content {
  border: 1px solid #959595;
  border-top: 0px solid #959595;
  border-bottom: 0px solid #959595;
  margin: 0px;
  padding: 2px 10px;
}

.box-title {
  margin: 0px;
  padding: 2px 10px;
  padding-bottom: 2px;
  padding-top: 10px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  border: 1px solid #959595;
  border-bottom: 0px solid #959595;
  background: #efefef;
}

.box-title h3 {
  padding-top: 5px;
  font-size: 16px;
}

.box-title .form-group {
  display: block;
  margin-top: 5px;
}

.alert {
  padding: 10px 20px;
}

.alert-success {
  background-color: #6ab04c;
  color: #fff;
}

.alert-danger {
  background-color: #eb4d4b;
  color: #fff;
}

.form-error {
  color: red;
  font-style: italic;
  font-size: 12px;
}

.custom-control-label {
  position: relative;
  margin-bottom: 0;
  vertical-align: top;
}

textarea {
  background-color: #d0e3f3;
  border-top-left-radius: 20px;
  border: 0px;
  height: 120px;
  width: 100%;
  padding-left: 10px;
  padding-top: 10px;
}

.form-group {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin-top: 15px;
  margin-bottom: 15px;
}

.form-group-buttons {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 20px;
  margin-bottom: 20px;
}

.form-group-title {
  display: block;
  margin-top: 15px;
  margin-bottom: 15px;
}

.form-group-buttons .btn {
  padding: 5px 20px;
}

.form-group-buttons .spinner {
  color: #000;
  font-size: 20px;
}

.form-vertical {
  flex-direction: column;
}

.col-form-label {
  padding-top: calc(.375rem + 1px);
  padding-bottom: calc(.375rem + 1px);
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
}

.form-control {
  display: block;
  width: 100%;
  height: calc(1.5em + .75rem + 2px);
  padding: .375rem .75rem;
  padding-left: 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

label {
  display: inline-block;
  /* margin-bottom: .5rem; */
}

.custom-control {
  position: relative;
}

.custom-control-inline {
  display: inline-flex;
  margin-right: 1rem;
}

/* .custom-control-input {
  position: absolute;
  left: 0;
  z-index: -1;
  width: 1rem;
  height: 1.25rem;
  opacity: 0;
} */

input[type="radio"] {
    appearance: auto;
    height: auto;
    -webkit-appearance: radio;
    /* margin-block: 3px 0;
    margin-inline: 5px 3px; */
}

textarea {
  height: 120px;
  width: 100%;
  padding-top: 10px;
}

input {
  background-color: #d0e3f3;
  border-top-left-radius: 20px;
  border: 0px;
  height: 35px;
  padding-left: 10px;
  -webkit-appearance: none;
  /* flex-basis: 50%; */
}

select {
  padding: 5px;
  font-size: 15px;
  line-height: 1;
  border: 0;
  border-top-left-radius: 20px;
  height: 35px;
  background: url("/img/select.png") no-repeat right #d0e3f3;
  -webkit-appearance: none;
  background-position-x: right;
  padding-left: 10px;
}

.spacer {
  margin-top: 20px;
}

/* Small devices (landscape phones, 576px and up) */
@media (max-width: 576px) {
  .website-container {
    max-width: 100%;
    margin-left: auto;
    margin-right: auto;
  }

  .navbar-logo {
    max-width: 100%;
    max-height: 60px;
    padding-left: 0px;
  }

  .navbar-brand {
    margin-left: 0px;
  }

  .main-nav {
    background: linear-gradient(90deg, #d0e3f3 0%, #262b55 80%, #262b55 100%);
    box-shadow: 0 10px 8px -8px #000;
  }

  .main-content .col {
    padding-left: 10px;
    padding-right: 10px;
  }

  .form-group {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    margin-top: 15px;
    margin-bottom: 15px;
  }
}

/* Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) {
  .website-container {
    max-width: 100%;
    margin-left: auto;
    margin-right: auto;
  }

  .navbar-logo {
    max-width: 100%;
    max-height: 60px;
    padding-left: 0px;
  }

  .navbar-brand {
    margin-left: 0px;
  }

  .main-nav {
    background: linear-gradient(90deg, #d0e3f3 0%, #262b55 80%, #262b55 100%);
    box-shadow: 0 10px 8px -8px #000;
  }

  .main-content .col {
    padding-left: 10px;
    padding-right: 10px;
  }

  .form-group {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    margin-top: 15px;
    margin-bottom: 15px;
  }
}

/* Medium devices (tablets, 768px and up) The navbar toggle appears at this breakpoint */
@media (min-width: 768px) {
  .website-container {
    max-width: 100%;
    margin-left: auto;
    margin-right: auto;
  }

  .navbar-logo {
    max-width: 100%;
    max-height: 60px;
    padding-left: 0px;
  }

  .navbar-brand {
    margin-left: auto!important;
  }

  .navbar-nav {
    margin-right: 20px;
  }

  .language .nav-item {
    margin-top: 0px;
    margin-bottom: 0px;
    margin-left: 5px;
    margin-right: 5px;
  }

  .main-nav {
    background: linear-gradient(90deg, #d0e3f3 0%, #262b55 40%, #262b55 100%);
    box-shadow: 0 10px 8px -8px #000;
  }

  .main-content .col {
    padding-left: 10px;
    padding-right: 10px;
  }

  .spacer {
    margin-top: 0px;
  }

  .form-group {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    margin-top: 15px;
    margin-bottom: 15px;
  }
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) {
  .website-container {
    max-width: 100%;
    margin-left: auto;
    margin-right: auto;
  }

  .navbar-logo {
    max-width: 100%;
    max-height: 60px;
    padding-left: 20px;
  }

  .main-nav {
    background: linear-gradient(90deg, #d0e3f3 0%, #262b55 40%, #262b55 100%);
    box-shadow: 0 10px 8px -8px #000;
  }

  .main-content .col {
    padding-left: 40px;
    padding-right: 40px;
  }

  .form-group {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    margin-top: 15px;
    margin-bottom: 15px;
  }
}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
  .website-container {
    max-width: 1366px;
    margin-left: auto;
    margin-right: auto;
  }

  .navbar-logo {
    max-width: 100%;
    max-height: 60px;
    padding-left: 20px;
  }

  .main-nav {
    background: linear-gradient(90deg, #d0e3f3 0%, #262b55 40%, #262b55 100%);
    box-shadow: 0 10px 8px -8px #000;
  }

  .form-group {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    margin-top: 15px;
    margin-bottom: 15px;
  }
}
</style>
